<template>
  <van-popup 
    v-model="show"
    position="bottom"
    :overlay-style="{zIndex:9998}"
    :overlay="false"
  >
    <div class="city-selected">
      <div class="city-search-box flex-sb">
        <van-icon name="cross" size="16px" color="#A4A4A4" style="margin:0 22px;font-weight:bold;" @click="show=false" />
        <van-field ref="search" left-icon="search" clearable v-model="searchValue" placeholder="请输入城市名搜索" />
      </div>
      <!-- 搜索结果 -->
      <div class="city-search-content" v-show="show&&showSearchContent">
        <van-empty description="未搜索到相关城市" image="search" v-if="searchValue&&!searchList.length" />
        <van-cell-group v-else>
          <van-cell 
            v-for="searchItem in searchList" 
            :key="`city${searchItem.name}`" 
            :title="searchItem.name"
            clickable
            size="large"
            :title-style="{
              color:'#130A01'
            }"
            @click="handleSearchItemConfirm(searchItem)"
          />
        </van-cell-group>
      </div>
      <van-index-bar ref="indexBar" :index-list="indexList" :sticky-offset-top="55">
        <van-index-anchor index="定位" v-if="locationPhoneInfo.city">当前定位</van-index-anchor>
        <div class="anchor-content" v-if="locationPhoneInfo.city">
          <!-- <div class="city-inline-block city-inline-block-active"><span class="location-icon">{{cityNameFormat(locationPhoneInfo.city)}}</span></div> -->
          <city-button class="location-button">
            <img :src="locationIconSrc" style="width:11px;height:14px;margin:0 5px 0 0;transform: translateY(1px);" alt="">
            <span>{{cityNameFormat(locationPhoneInfo.city)}}</span>
          </city-button>
        </div>
        <van-index-anchor index="历史">最近使用</van-index-anchor>
        <div class="anchor-content">
          <city-button :class="{'button-active':index===0}" v-for="(cityName,index) in searchHistoryList" :key="cityName" @click.native="handleHistortConfirm(cityName)">{{cityNameFormat(cityName)}}</city-button>
        </div>
        <van-index-anchor index="热门" v-if="hotCityList&&hotCityList.length">热门城市</van-index-anchor>
        <div class="anchor-content" v-if="hotCityList&&hotCityList.length" >
          <city-button v-for="(item) in hotCityList" :key="`hot${item.code}`" @click="handleCityConfirm(item)">{{cityNameFormat(item.name)}}</city-button>
        </div>
        <van-index-anchor index="索引" v-if="locationPhoneInfo.city">字母索引</van-index-anchor>
        <div class="anchor-content">
          <city-button v-for="(item) in lettersList" :key="`button${item}`" @click.native="handleScrollTo(item)">{{item}}</city-button>
        </div>
        <div v-for="cityIndex in lettersList" :key="`cityIndex${cityIndex}`">
          <van-index-anchor :index="cityIndex">{{cityIndex}}</van-index-anchor>
          <div class="anchor-content" style="padding-left:10px;">
            <van-cell-group>
              <van-cell 
                v-for="cityItem in cityList[cityIndex]" 
                :key="`city${cityItem.name}`" 
                :title="cityItem.name"
                clickable
                size="large"
                :title-style="{
                  color:'#130A01'
                }"
                @click="handleCityConfirm(cityItem)"
              />
            </van-cell-group>
          </div>
        </div>
      </van-index-bar>
    </div>
  </van-popup>
</template>

<script>
import { Popup , Field , Icon , IndexBar , IndexAnchor , Cell, CellGroup , Empty , Toast } from 'vant';
import { getHotCity , getCityList } from '@/api/beecargo/addressBook/components/city-selected.js';
import cityButton from './city-button.vue';
export default {
  props:['locationPhoneInfo','mapCenterInfo','map'],
  components:{
    [Popup.name]:Popup,
    [Field.name]:Field,
    [Icon.name]:Icon,
    [IndexBar.name]:IndexBar,
    [IndexAnchor.name]:IndexAnchor,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup,
    [Empty.name]:Empty,
    [Toast.name]:Toast,
    cityButton
  },
  data(){
    // const lettersList = Array.from(new Array(26),(ele,index)=>String.fromCharCode(65+index));
    // let indexList = ['定位','历史','热门','索引',...lettersList]
    return {
      show:false,
      searchValue:'',
      searchList:[],  //搜索结果列表
      searchHistoryList:[],  //历史搜索
      hotCityList:[],  //热门城市列表
      indexList:['定位','历史','热门','索引'],  //页面右侧的索引列表(用于跳转)
      lettersList:[],  //字母索引列表
      cityList:{},  //城市列表（以索引为key，value为array）
      mapPanendDisabled:true,  //控制平移结束方法是否执行
      cityListValue:[],
      showSearchContent:false
    }
  },
  watch:{
    /* 将当前地图中心点所在城市名称放在历史搜索数组的第一位 */
    'mapCenterInfo.city':{
      handler(val){
        if(!val||typeof val !== 'string') return;
        let searchHistoryList = this.deepClone(this.searchHistoryList);
        searchHistoryList.unshift(this.cityNameFormat(val));
        searchHistoryList = Array.from(new Set(searchHistoryList));
        this.searchHistoryList = searchHistoryList.slice(0,4);
      },
      immediate:true
    },
    searchValue:{
      handler(value){
        this.handleQuery(value);
      },
      immediate:true
    },
    async show(val){
      if(!val) return;
      if(!this.hotCityList||(this.hotCityList&&this.hotCityList.length==0)){
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration:0
        });
        await this.getHotCity();
        Toast.clear();
      }
      if(!this.cityList||!Object.keys(this.cityList).length){
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration:0
        });
        await this.getCityList();
        Toast.clear();
      }
    }
  },
  created(){
    this.getHotCity();
    this.getCityList();
    this.$bus.on('showCitySelected',this.handleShowCitySelected);
  },
  beforeDestroy(){
    this.$bus.off('showCitySelected',this.handleShowCitySelected);
  },
  computed:{
    locationIconSrc(){
      if(process.env.VUE_APP_BEECARGO_STATIC){
        return `${process.env.VUE_APP_BEECARGO_STATIC}/img/orientation.png`;
      }else return '';
    }
  },
  methods:{
    /* 城市搜索列表的确定 */
    handleSearchItemConfirm(item){
      this.handleCityConfirm(item);
      this.searchValue = '';
    },
    /* 显示城市选择 */
    handleShowCitySelected(boolean){
      this.show = boolean;
    },
    /* 历史记录城市的确定 */
    handleHistortConfirm(cityName){
      this.cityListValue.some(item=>{
        let itemName = this.cityNameFormat(item.name);
        if(itemName === cityName) {
          this.handleCityConfirm(item);
          return true;
        }else return false;
      });
    },
    /* 跳转索引 */
    handleScrollTo(index){
      this.$refs['indexBar'].scrollTo(index)
    },
    /* 城市选择 */
    handleCityConfirm(item){
      this.$emit('confirm',item);
      // this.mapPanendDisabled = false;
      this.map.setCenter(new window.TMap.LatLng(item.latitude, item.longitude));
      this.$emit('getMapCenter',{LatLng:{
        lat:item.latitude,
        lng:item.longitude
      }});
      this.show = false;
      this.handleUnshiftSearchHistoryList(item.name);
    },
    /* 挂载panend方法，需要在主页面的map实例初始化后由主页面主动调用该方法 */
    mountPanend(map){
      map.on('panend',this.mapPanend);
    },
    /** 地图平移结束 
     * 因为主动调用腾讯的panTo方法 在平移结束后只会触发腾讯panend方法
     * 手动拖拽结束后会同时触发 panend 和 dragend 方法
     */
    mapPanend(){
      if(this.mapPanendDisabled) return;
      this.$emit('getMapCenter');
      this.mapPanendDisabled = true;
    },
    /* 添加历史记录 */
    handleUnshiftSearchHistoryList(cityName){
      let searchHistoryList = this.deepClone(this.searchHistoryList);
      searchHistoryList.unshift(this.cityNameFormat(cityName));
      searchHistoryList = Array.from(new Set(searchHistoryList)).slice(0,4);
      this.searchHistoryList = searchHistoryList;
    },
    /* 搜索 */
    handleQuery(value){
      if(!value) {
          this.showSearchContent = false;
          this.searchList = [];
        }else {
          this.searchList = this.cityListValue.filter(item=>{
            return ~item.name.indexOf(value);
          })
          this.showSearchContent = true;
        }
    },
    /* 获取热门城市 */
    getHotCity(){
      return getHotCity()
      .then(({ data })=>{
        this.hotCityList = data;
      })
    },
    /* 获取地级城市 */
    getCityList(){
      return getCityList()
      .then(({ data })=>{
        this.cityList = data;
        this.lettersList = Object.keys(data);
        this.indexList = this.indexList.concat(this.lettersList);
        this.getCityListValue(data);
      })
    },
    getCityListValue(data){
      let cityListValue = []
      Object.values(data).map(item=>{
        cityListValue = cityListValue.concat(item)
      });
      this.cityListValue = cityListValue;
    }
  }
}
</script>

<style scoped lang="scss">
  .van-popup--bottom {
    z-index: 9999 !important;
  }
  .city-selected {
    height: 100vh;
    box-sizing: border-box;
    overflow-y: auto;
    padding-top: 55px;
    .city-search-box {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      z-index: 999;
      height: 33px;
      padding-right: 22px;
      padding-bottom: 22px;
      background-color: #FFF;
      ::v-deep .van-field {
        height: 33px;
        padding: 0 10px ;
        background-color: #F7F7F7;
        border-radius: 20px;
        overflow: hidden;
        .van-field__left-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .van-field__body {
          height: 100%;
        }
      }
    }
    .city-search-content {
      position: fixed;
      left: 0;
      top: 33px;
      right: 0;
      bottom: 0;
      z-index: 999;
      padding-top: 26px;
      background-color: #FFF;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .location-button {
      color: #F1892E;
      border-color: #F1892E;
    }
    ::v-deep .van-index-anchor {
      font-size: 18px;
      color: #130A01;
      font-weight: bold;
    }
    ::v-deep .van-index-bar__index--active {
      color: #F1892E;
    }
    .anchor-content {
      padding:15px 12px 35px 25px;
    }
  }
</style>